// extracted by mini-css-extract-plugin
export default {"root":"PasswordRestore_root__OkGvA","container":"PasswordRestore_container__tOjL-","header":"PasswordRestore_header__DiSY-"};